
import Vue from 'vue';
export default {
    setHotel(state, data) {
        Vue.set(state.hotel, data.backCodeTMS,  data);
    }
}